import React from "react";
import { Row, Col, ListGroup } from "react-bootstrap";
import AuthenticatedWrapper from "../../../components/wrapper";
import { useLocation } from "react-router-dom";
import { LayoutDashboard, Users, BarChart3, Building2 } from "lucide-react";

function DashboardLayout({ user, children }) {
  const location = useLocation();
  const getActiveKey = () => {
    const path = location.pathname;
    if (path.includes("/placements")) return "#/local-authority/dashboard/placements";
    if (path.includes("/insights")) return "#/local-authority/dashboard/insights";
    if (path.includes("/services")) return "#/local-authority/dashboard/services";
    return "#/local-authority/dashboard"; // default to dashboard
  };

  const activeKey = getActiveKey();

  return (
    <AuthenticatedWrapper user={user}>
      <div style={{ marginTop: "0", padding: "0 0px" }}>
        <Row className="" style={{ marginTop: 0, minHeight: "100vh" }}>
          <Col
            className="d-flex flex-column justify-end align-items-start bg-primary"
            lg={2}
          >
            <ListGroup activeKey={activeKey} className="dashboard-sidebar w-100 p-0 py-4">
              <ListGroup.Item
                className="border-0 rounded-lg d-flex align-items-center"
                action
                href="#/local-authority/dashboard"
              >
                <LayoutDashboard size={20} className="me-2" />
                Dashboard
              </ListGroup.Item>
              <ListGroup.Item
                className="border-0 rounded-lg d-flex align-items-center"
                action
                href="#/local-authority/dashboard/placements"
              >
                <Users size={20} className="me-2" />
                Placements
              </ListGroup.Item>
              <ListGroup.Item
                className="border-0 rounded-lg d-flex align-items-center"
                action
                href="#/local-authority/dashboard/insights"
              >
                <BarChart3 size={20} className="me-2" />
                Insights
              </ListGroup.Item>
              <ListGroup.Item
                className="border-0 rounded-lg d-flex align-items-center"
                action
                href="#/local-authority/dashboard/services"
              >
                <Building2 size={20} className="me-2" />
                Services
              </ListGroup.Item>
            </ListGroup>
          </Col>
          <Col className="p-4" lg={10}>
            {children}
          </Col>
        </Row>
      </div>
    </AuthenticatedWrapper>
  );
}

export default DashboardLayout;

